<div class="loader loader--{{ color }}">
  @for (number of [0, 1, 2, 3, 4, 5]; track number) {
    <div class="loader__dot"></div>
  }
</div>
